import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=3dcfaf2a&"
import script from "./PermissionList.vue?vue&type=script&lang=js&"
export * from "./PermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcfaf2a')) {
      api.createRecord('3dcfaf2a', component.options)
    } else {
      api.reload('3dcfaf2a', component.options)
    }
    module.hot.accept("./PermissionList.vue?vue&type=template&id=3dcfaf2a&", function () {
      api.rerender('3dcfaf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/PermissionList.vue"
export default component.exports